export type TicketAttachment = { messageId: number; index: number; file: string; name: string };
export type TicketSnapshot = { id: number; title: string; paragraphs: string[]; attachments: TicketAttachment[] };
export type TicketExportResult = { warnings: string[] };

/** Capture all rendered ticket text, including scrolled content, but no controls or hidden content. */
export function captureTicket(root: HTMLElement, id: number, title: string): TicketSnapshot {
  const paragraphs: string[] = [], attachments: TicketAttachment[] = [];
  let text = "";
  const flush = () => { if (text.trim()) paragraphs.push(text.trim()); text = ""; };
  const walk = (node: Node) => {
    if (node.nodeType === 3) { text += node.textContent ?? ""; return; }
    if (!(node instanceof HTMLElement)) return;
    if (node.matches('[data-ticket-controls], [hidden], [aria-hidden="true"]')) return;
    const style = getComputedStyle(node);
    if (style.display === "none" || style.visibility === "hidden") return;
    if (node.hasAttribute("data-ticket-attachment")) {
      flush();
      const name = node.textContent?.trim() || node.dataset.ticketFile || "Anhang";
      paragraphs.push(`Anhang: ${name}`);
      attachments.push({ name, file: node.dataset.ticketFile ?? "", messageId: Number(node.dataset.ticketMessage), index: Number(node.dataset.ticketIndex) });
      return;
    }
    if (node.matches('button, input, textarea, select, [role="button"]')) return;
    if (node.tagName === "BR") { text += "\n"; return; }
    const block = /^(DIV|P|H[1-6]|LI|SECTION|ARTICLE)$/.test(node.tagName);
    if (block) flush();
    if (node.dataset.ticketLabel) text += node.dataset.ticketLabel + " ";
    for (const child of node.childNodes) walk(child);
    if (block) flush();
  };
  walk(root); flush();
  return { id, title, paragraphs, attachments };
}
